// import config from 'config';
import { authHeader } from '../../_helpers';
import axios from 'axios';
import swal from 'sweetalert2';


export const sellerImageService = {
    setSellerImage,
    removeSellerImage
};

axios.defaults.headers.common = authHeader();


function setSellerImage(data, id) {

    return axios.post('/users/seller/image/upload/' + id + '/', data)
        .then(response => {
            return response;
        }
        )
}

function removeSellerImage(data) {
    return axios.post('/users/seller/image/delete/', data)
        .then(response => {
            return response;
        })
}


// WEBPACK FOOTER //
// ./src/_services/sellers/sellerImage.service.js